import { Component } from '@angular/core';

@Component({
    selector: 'app-accesibilite',
    templateUrl: './accesibilite.component.html',
    styleUrls: ['./accesibilite.component.scss']
})
export class AccesibiliteComponent {
    // Ajoutez ici les propriétés et méthodes de votre composant
}